<template>
    <section class="links-wrapper">
        <ul class="links-list">
            <unit-list-item v-for="item in data" :key="item.name" :type="item" v-if="item.unit"></unit-list-item>
        </ul>
    </section>
</template>

<script>
    import UnitListItem from './UnitListItem.vue'

    export default {
        components: {
            UnitListItem
        },
        props: {
            hemoglobin: {
                type: String,
                required: false
            },
            glycaemia: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                data: {
                    hemoglobin: {
                        name: 'hemoglobin',
                        unit: this.hemoglobin === '%' ? lang.get('% (percentage)') : this.hemoglobin
                    },
                    glycaemia: {
                        name: 'glycaemia',
                        unit: this.glycaemia
                    }
                }
            }
        }
    }
</script>
